module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_fz-ad5035cb9bf1574e611b897646c6bcf4.png";